import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import amplitudeKodakTracking from '../../../services/amplitude/amplitudeKodakTracking';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import appRouterService from '../../../services/route/appRouterService';
import {selectIsDeviceReady} from '../../../state/selectors/iotDevice';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import helpers from '../../../utils/helpers';
import {AppButton} from '../../Button';
import InternetAndDeviceTrackButton from '../../Button/ConnectionAndDeviceTrackButton/InternetAndDeviceTrackButton';
import {Article} from '../../DataDisplay';
import {FirmwareUpdateBlueIcon} from '../../Icons';
import LeviaFwuNewFeatures from './LeviaFwuNewFeatures';

const LeviaFwuArticle = ({onClick, onCancel, isUsage}) => {
    const isDeviceReady = useSelector(selectIsDeviceReady);
    const localizedStrings = getLocalizedStrings();

    const onUpdateClick = () => {
        helpers.runFunction(onClick);
        appRouterService.forwardToUpdateSummaryPage();
    };

    useEffect(() => {
        if (isUsage) return;

        amplitudeKodakTracking.trackUpdateFirmwareScreen();
    }, []);

    return (
        <Article
            icon={<FirmwareUpdateBlueIcon className='h-16 w-16' />}
            titleClassName='text-28 mt-4'
            titleKey={localizationKeys.FIRMWARE_MODAL_VIEW_TITLE}
            descriptionKey={localizationKeys.FIRMWARE_MODAL_VIEW_DESCRIPTION}
        >
            <LeviaFwuNewFeatures />
            <InternetAndDeviceTrackButton
                isDeviceReady={isDeviceReady}
                button={AppButton}
                className='mt-16 max-w-[312px] md:mt-8'
                primary
                light
                onClick={onUpdateClick}
                testId={elementsTesIds.ONBOARD_LEVIA_BTN_UPDATE}
            >
                {localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_UPDATE_BUTTON]}
            </InternetAndDeviceTrackButton>
            {onCancel && (
                <AppButton
                    testId={elementsTesIds.ONBOARD_LEVIA_BTN_NOT_NOW}
                    tertiary
                    className='mt-3 text-center md:mt-4'
                    onClick={onCancel}
                >
                    {localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_SKIP_UPDATE_BUTTON]}
                </AppButton>
            )}
        </Article>
    );
};

export default LeviaFwuArticle;
